var md5 = require("md5");
import config from "@/config";
import axios from "axios";
export default {
  methods: {
    now() {
      const date = new Date();
      return parseInt(date.getTime() / 1000);
    },
    generalCatch(error, reject) {
      console.log("error", error);
      if (error.error) error = error.error;
      if (error.code !== undefined)
        error.code = error.code.toString().replace("/", "-");
      this.$notification["error"]({
        message:
          this.$t("notify.title.error") + " " + error.code.split("/").pop(),
        description: error.message
          ? this.$t("notify.content." + error.message)
          : this.$t("notify.content." + error.code)
      });
      reject && reject(error);
    },
    async api(path, data = null, showError = true) {
      function generate_signature(args) {
        let tmp_string = args.time + config.secretToken;
        if (args.data) tmp_string += args.data;
        return `time=${args.time}&sig=` + md5(tmp_string);
      }

      let token = "";
      if (this.$auth.user()) token = await this.$auth.user().getIdToken();

      if (data && typeof data !== "string") data = JSON.stringify(data);
      let query = generate_signature({ time: this.now(), data });
      const url =
        config.apiURL +
        "/" +
        path +
        (path.indexOf("?") > 0 ? "&" : "?") +
        query;
      let request_config = {};
      if (token && token.length) {
        request_config.headers = {
          Authorization: "Bearer " + token
        };
      }
      if (data) {
        request_config["method"] = "POST";
        request_config["body"] = data;
      }
      return new Promise((resolve, reject) => {
        fetch(url, request_config)
          .then(response => {
            return response.json().then(json_data => {
              if (json_data == null) reject(json_data);
              else if (json_data["error"] !== undefined) {
                if (showError) this.generalCatch(json_data["error"]);
                reject(json_data);
              } else resolve(json_data);
            });
          })
          .catch(error => {
            console.log(error);
            const return_error = {
              code: "-1",
              explain: "Network error"
            };
            showError && this.generalCatch(return_error);
            reject({
              error: return_error
            });
          });
      });
    },
    async imgurUpload(file) {
      if (!file || file.size > 10 * 1024 * 1024) return "invalid_image";
      const { token } = await this.api("other/token");
      const data = new FormData();
      data.append("media", file);
      console.log(token);
      let result = await axios.post(
        "https://m3dia.gostream.co/v1/files/upload",
        data,
        {
          headers: {
            Authorization: "Bearer " + token
          }
        }
      );
      return result.data[0].url;
    },
    async imgMitiUpload(files) {
      let images =  Object.values(files);
      const data = new FormData();
      const { token } = await this.api("other/token");
      images.forEach(image =>{
        if (!image || image.size > 10 * 1024 * 1024) return "invalid_image";
        data.append("media", image);
      })

      console.log(token);
      let result = await axios.post(
        "https://m3dia.gostream.co/v1/files/upload",
        data,
        {
          headers: {
            Authorization: "Bearer " + token
          }
        }
      );
      console.log(result)
      return result.data.map(res =>{
        return res.url
      });
    }

  }
};
